'use strict';

(function ($) {
  const slideShow = $('#block-views-block-projecten-slideshow-block-front');
  if (!slideShow.length) {
    return;
  }
  $(slideShow).find('.widget_pager').find('a').click(function(e) {
    e.preventDefault();
  });
})(jQuery);
